import React, { Component, Fragment } from 'react';
import { Image, View, StyleSheet } from 'react-native';
import { Button, Text } from 'trpc-react-native-ui';

import theme from '../../../../theme-config';
import I18n from '../../../../lib/i18n';

export default class Choice extends Component<Props> {
  styles = getStyles();

  onPress = () => this.props.onSelect(this.props.choice);

  renderDeliveryPartner = () => {
    const styles = this.styles;
    const { choice } = this.props;

    if (choice.type === 'PREMIUM' && choice.characteristics && choice.characteristics.DeliveryPartner) {
      const deliveryPartnershipImage =
        theme.deliveryPartnershipImages && theme.deliveryPartnershipImages[choice.characteristics.DeliveryPartner];
      return (
        <View style={styles.goGetContainer}>
          {deliveryPartnershipImage ? (
            <Fragment>
              <Text style={styles.poweredBy}>{I18n.t('SignUp.DeliveryMethod.poweredBy')}</Text>
              <Image source={deliveryPartnershipImage} style={styles.goGetLogo} resizeMode="contain" />
            </Fragment>
          ) : (
            <Text style={styles.poweredBy}>
              {I18n.t('SignUp.DeliveryMethod.poweredBy') + ' ' + choice.characteristics.DeliveryPartner}
            </Text>
          )}
        </View>
      );
    }

    return null;
  };

  render() {
    const styles = this.styles;
    const { selected, choice } = this.props;

    return (
      <Button
        onPress={this.onPress}
        style={[styles.container, choice.disabled && styles.disabled]}
        disabled={choice.disabled}
        testID={choice.id}
      >
        <View style={styles.row}>
          <View style={styles.radioButtonColumn}>
            <View style={[styles.radioButtonOuterRing, selected && styles.selectedRadioButtonOuterRing]}>
              {selected && <View style={styles.selectedRadioButton} />}
            </View>
          </View>
          <View style={styles.titleAndPriceContainer}>
            <Text style={[styles.text, styles.title, selected && styles.selectedTitle]}>
              {I18n.t(`SignUp.DeliveryMethod.methods.${choice.type}.title`)}
            </Text>
            {choice.price !== null && !choice.disabled && (
              <Text style={[styles.text, styles.price, selected && styles.selectedPrice]}>
                {choice.price !== 0 ? I18n.toPrice(choice.price) : I18n.t('prices.free')}
              </Text>
            )}
          </View>
        </View>
        <View style={[styles.row, styles.descriptionRow]}>
          <View style={styles.radioButtonColumn} />
          <View style={styles.descriptionContainer}>
            <Text style={[styles.text, styles.description, selected && styles.selectedDescription]}>
              {choice.disabled && choice.type === 'PREMIUM'
                ? I18n.t(`SignUp.DeliveryMethod.methods.${choice.type}.whenUnavailable`)
                : I18n.t(`SignUp.DeliveryMethod.methods.${choice.type}.description`, {
                    duration: choice.duration,
                  })}
            </Text>
            {this.renderDeliveryPartner()}
          </View>
        </View>
      </Button>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    disabled: {
      opacity: 0.5,
    },
    container: {
      paddingTop: 15,
      paddingBottom: 10,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    radioButtonColumn: {
      width: 40,
    },
    radioButtonOuterRing: {
      width: 25,
      height: 25,
      borderWidth: 2,
      borderRadius: 50,
      borderColor: theme.signUpDeliveryMethodChoice,
      alignItems: 'center',
      justifyContent: 'center',
    },
    selectedRadioButtonOuterRing: {
      borderColor: theme.signUpSelectedDeliveryMethodChoice,
      borderWidth: 3,
    },
    selectedRadioButton: {
      width: 17,
      height: 17,
      borderRadius: 40,
      backgroundColor: theme.signUpSelectedDeliveryMethodChoice,
    },
    text: {
      color: theme.signUpDeliveryMethodChoice,
      backgroundColor: 'transparent',
      fontWeight: '300',
    },
    titleAndPriceContainer: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    title: {
      flex: 0.6,
      fontSize: 24,
    },
    selectedTitle: {
      color: theme.signUpSelectedDeliveryMethodChoice,
      fontWeight: 'normal',
    },
    price: {
      flex: 0.4,
      fontWeight: 'normal',
      fontSize: 24,
      textAlign: 'right',
    },
    selectedPrice: {
      color: theme.signUpSelectedDeliveryMethodChoice,
      fontWeight: 'bold',
    },
    descriptionRow: {
      marginTop: 8,
    },
    descriptionContainer: {
      flex: 1,
    },
    description: {
      flexDirection: 'column',
      fontSize: 18,
    },
    smallDescription: {
      flexDirection: 'column',
      fontSize: 15,
    },
    selectedDescription: {
      color: theme.signUpSelectedDeliveryMethodChoice,
      fontWeight: 'normal',
    },
    goGetContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 15,
      marginTop: 8,
    },
    goGetLogo: {
      width: 63,
      height: 35,
    },
    poweredBy: {
      marginRight: 10,
      color: theme.signUpPoweredByColor,
    },
  });

type Props = {
  choice: any,
  selected: boolean,
  onSelect: Function,
  characteristics?: {
    AvailabilityStartDT: number,
    AvailabilityEndDT: number,
    DeliveryPartner: string,
  },
};
